<template>
  <page-wrapper v-bind="pageWrapper">
    <div class="header wrapper">
      <div class="row mb-3">
        <div class="col-3">
          <div class="label mb-2">ชื่อแพ็กเกจ</div>
          <el-input v-model="form.packageName" />
        </div>
        <div class="col-3">
          <div class="label mb-2">โครงการ</div>
          <project-select v-model="form.selectedProject"></project-select>
        </div>
      </div>
      <div class="text-right">
        <sc-button variant="primary" @click="handleClickSearch">ค้นหา</sc-button>
      </div>
    </div>
    <div class="wrapper small" v-if="total > 0">
      <p class="mb-2 mt-2">{{ totalCount }}</p>
    </div>
    <router-link
      :to="presenter.route"
      class="requested-package-item"
      v-for="presenter in requestedPackagePresenters"
      :key="presenter.key"
    >
      <h4 class="title">{{ presenter.name }}</h4>
      <p
        class="desc"
      >มี {{ presenter.numberOfRequested }} คน จาก {{ presenter.numberOfProjects }} โครงการ ต้องการ Package นี้</p>
    </router-link>
    <div class="wrapper small text-right mt-4" v-if="list.length">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :size="10"
        :current-page="queryParams.page"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
    <div class="wrapper text-center" v-else>
      <h1>ไม่มีข้อมูล</h1>
    </div>
  </page-wrapper>
</template>

<script>
import { Input as ElInput, Pagination as ElPagination } from "element-ui";

import PageWrapper from "@/lib/components/PageWrapper";
import ProjectSelect from "@/lib/components/ProjectSelect";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import { toCamelCaseObject } from "@/lib/util";
import { formatNumber } from "@/lib/formatter";

export default {
  components: { ElInput, ElPagination, PageWrapper, ProjectSelect, ScButton },
  data() {
    const list = [];
    const form = {
      packageName: "",
      selectedProject: null
    };
    const total = 0;

    return {
      list,
      form,
      total
    };
  },
  computed: {
    pageWrapper() {
      return {
        title: "Requested Package"
      };
    },
    requestedPackagePresenters() {
      return this.list.map((requested, index) => {
        const key = requested.packageId;
        const name = requested.packageName;
        const numberOfProjects = formatNumber(requested.projectCount);
        const numberOfRequested = formatNumber(requested.requestCount);
        const id = key;
        const route = { name: "RequestedPackageDetailPage", params: { id } };

        return { key, name, numberOfProjects, numberOfRequested, route };
      });
    },
    totalCount() {
      const limit = 10;
      const total = this.total.toLocaleString();
      const currentTotalItem = this.list.length;
      const isLastPage = limit > currentTotalItem;
      const currentPage = this.queryParams.page;
      const end = (isLastPage ? total : currentPage * limit).toLocaleString();
      const start = ((isLastPage ? limit * currentPage - limit : end - limit) + 1).toLocaleString();

      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`;
    },
    queryParams() {
      return {
        page: parseInt(this.$route.query.page) || 1,
        packageName: this.$route.query.packageName || null,
        projectId: this.$route.query.projectId || null
      };
    }
  },
  mounted() {
    this.setup();
  },
  watch: {
    "$route.query": "setupData"
  },
  methods: {
    setup() {
      this.setupQuery();
      this.setupData();
    },
    setupQuery() {
      this.form = { packageName: this.queryParams.packageName, selectedProject: { projectId: this.queryParams.projectId } };
    },
    async setupData() {
      const { requestPackages, count } = await this.fetchList();

      this.list = requestPackages;
      this.total = count;
    },
    async fetchList() {
      const response = await baanRueJaiClient.admin.subscriptions.recommend_packages.getRequestPackage(this.queryParams);

      return toCamelCaseObject(response.data.result);
    },
    handleClickSearch() {
      this.$router.replace({ query: { ...this.$route.query, packageName: this.form.packageName, projectId: this.form.selectedProject && this.form.selectedProject.projectId } });
    },
    handleCurrentChange(page) {
      this.$router.replace({ query: { ...this.$route.query, page } });
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  background: #f9f9f9;
  border-bottom: 1px solid #e0e0e0;
}

.wrapper {
  padding: 2rem;
}

.wrapper.small {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.requested-package-item {
  display: block;
  padding: 0.5rem 2rem;

  &:hover {
    text-decoration: none;
    background: #f0f0f0;
  }

  > .title,
  > .desc {
    margin: 0;
    line-height: 1.7;
  }

  > .title {
    font-size: 1rem;
    font-weight: normal;
  }

  > .desc {
    color: #888;
    font-size: 0.875rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/requested-packages/pages/RequestedPackageListPage.vue